import { AppStore } from "@/store/AppStore";
import { DateTime } from "luxon";
import { ApiSchema } from "@/modules/api";

/**
 * OpenAPI widens feature and limit map keys to string, so mem-client owns the
 * subset it knows how to handle. The backend may grow ahead of the frontend;
 * consumers must tolerate missing entries and fall back safely.
 */
export type GatedFeatureConfigMap = Partial<Record<GatedFeature, GatedFeatureConfig>>;
export type SerializableGatedFeatureConfigMap = Partial<
  Record<GatedFeature, Omit<GatedFeatureConfig, "counter">>
>;
export type GatedFeatureConfigMapData = Partial<
  Record<GatedFeature, Omit<GatedFeatureConfig, "counter">>
>;

export interface GatedFeatureConfig {
  period: GatingPeriod;
  limits: FeatureLimits;
  counter: (ctx: GateUsageCounterContext) => number;
}

export const GatedFeature = {
  NoteCreate: "note.create",
  ChatMessageSend: "chat_message.send",
  NativeChatMessageSend: "native_chat_message.send",
  DarkMode: "dark_mode",
  ContentUnderstandingPdfPage: "content_understanding.pdf_page",
} as const;
export type GatedFeature = (typeof GatedFeature)[keyof typeof GatedFeature];

export const GatingPeriod = {
  Monthly: "monthly",
} as const;
export type GatingPeriod = (typeof GatingPeriod)[keyof typeof GatingPeriod];

export type PlanId = ApiSchema["PlanId"];
export const PlanId = {
  Free: "free" as PlanId,
  Paid: "paid" as PlanId,
} as const;

export const FeatureLimit = {
  Free: "free",
  Paid: "paid",
  Pro: "pro",
  Proactive: "proactive",
  Warning: "warning",
} as const;
export type FeatureLimit = (typeof FeatureLimit)[keyof typeof FeatureLimit];

export type FeatureLimits = Partial<Record<FeatureLimit, number | null>> & {
  free: number | null;
};

export interface GateUsageCounterContext {
  store: AppStore;
  periodStart: DateTime;
  periodEnd: DateTime;
}

export type GateUsage = {
  allowed: boolean;
  used: number;
  limit: number;
};
